import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="visits--visit-page"
export default class extends Controller {
  loadPrepPlan(event) {
    $('#prep-plan-picker')[0].requestSubmit();
  }
}
